// extracted by mini-css-extract-plugin
export default {"card":"HighlightCard_card__q1R0c","label":"HighlightCard_label__lu3lS"};